import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PurePipe } from './pure.pipe';

@NgModule({
  declarations: [PurePipe],
  imports: [CommonModule],
  exports: [PurePipe],
})
export class PureModule {}
